import { CHECKOUT2_TYPE_REDUCER } from '../../constants/common'

const commonReducer = (state = {}, action: any) => {
    switch (action.type) {
        case CHECKOUT2_TYPE_REDUCER.SET_PAYMENT_METHOD:
            return {
                ...state,
                paymentMethod: action.paymentMethod
            }
        case CHECKOUT2_TYPE_REDUCER.SET_REFRESH_PAGE:
            return {
                ...state,
                refreshPage: action.refreshPage
            }
        case CHECKOUT2_TYPE_REDUCER.SET_VALUE_PROGRESS:
            return {
                ...state,
                valueProgress: action.valueProgress
            }
        default:
            return { ...state }
    }
}

export default commonReducer
